<div class="incoming-call-dialog">
  <mat-icon class="ringing-icon" color="primary">ring_volume</mat-icon>
  <div class="caller-info">
    <span class="caller-name">{{ callerName || "Someone" }}</span>
    <span class="call-text">is calling you...</span>
  </div>
  <div class="button-row">
    <button mat-fab color="primary" (click)="acceptCall()">
      <mat-icon>call</mat-icon>
    </button>
    <button mat-fab color="warn" (click)="declineCall()">
      <mat-icon>call_end</mat-icon>
    </button>
  </div>
</div>
